import styles from "./RecipeCardSkeleton.module.scss";

export const RecipeCardSkeleton = () => {
  return <li className={styles["card-skeleton"]} />;
};
